import { AcademicYear } from './AcademicYear';
import { AllApplicantsService } from './applicants.service';
import { Applicants } from './Applicants';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { map, shareReplay } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { MatSort, Sort } from '@angular/material/sort';
import { CommonService } from '../common/common.services';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-applicants',
  templateUrl: './applicants.component.html',
  styleUrls: ['./applicants.component.scss'],
})
export class AllApplicantsComponent implements OnInit {
  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay(),
    );

  displayedColumns: string[] = [
    'id',
    'Applicant',
    'ProgrammeType',
    'Country',
    'Hometown',
    'Sex',
    'Date',
    'Semester',
    'Status',
    'applicantType',
    'Download',
  ];
  dataSource: MatTableDataSource<Applicants>;

  years: AcademicYear[];
  applicants: Applicants[];
  sortedApplicants: Applicants[];
  year: string;
  totalApplicants: number;
  totalDiplomaApplicants: number;
  totalDegreeApplicants: number;
  totalCertificateApplicants: number;

  public loading = false;

  constructor(
    private router: Router,
    private allApplicantsService: AllApplicantsService,
    private breakpointObserver: BreakpointObserver,
    private commonService: CommonService,
  ) {}

  ngOnInit() {
    this.loading = true;
    this.allApplicantsService.getCurrentYear().subscribe((currentYear) => {
      console.log(currentYear.response);
      this.allApplicantsService.getAcademicYears().subscribe((response) => {
        this.years = response;
        this.year = currentYear.response;
        this.allApplicantsService
          .getAllApplicants(this.year)
          .subscribe((applicants) => {
            this.applicants = applicants;
            this.dataSource = new MatTableDataSource(this.applicants);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
            setTimeout(()=>{
              this.populateApplicantsNo();
              this.loading = false;
            }, 3000)
  
          });
      });
    });
  }

  private populateApplicantsNo() {
    this.totalApplicants = this.applicants.length;
    this.totalDiplomaApplicants = this.applicants.filter(
      (applicant) => applicant.programmeType.indexOf('Diploma') !== -1,
    ).length;
    this.totalDegreeApplicants = this.applicants.filter(
      (applicant) => applicant.programmeType.indexOf('Bachelor') !== -1,
    ).length;
    this.totalCertificateApplicants = this.applicants.filter(
      (applicant) => applicant.programmeType.indexOf('Certificate') !== -1,
    ).length;
  }

  fetchApplicantList(year: string) {
    console.log('Selected year: ' + year);
    this.year = year;
    this.allApplicantsService.getAllApplicants(year).subscribe((response) => {
      this.applicants = response;
      this.dataSource = new MatTableDataSource(this.applicants);
      this.dataSource.paginator = this.paginator;
      this.populateApplicantsNo();
    });
  }

  goToApplicantDetails(applicantId: string) {
    this.router.navigateByUrl(
      '/applicant?applicantId=' + applicantId + '&year=' + this.year,
    );
  }

  downloadExcelFile() {
    this.allApplicantsService
      .getAllApplicantsExcelFile(this.year)
      .subscribe((blob) => {
        saveAs(blob, 'AUCDT Applicants.xlsx');
      });
  }

  downloadPdf(applicantId: string) {
    this.allApplicantsService
      .getApplicantPDFFile(applicantId)
      .subscribe((blob) => {
        saveAs(blob, applicantId + '.pdf');
      });
  }

  sortData(sort: Sort) {
    this.sortedApplicants = this.applicants.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'id':
          return this.commonService.compare(a.personId, b.personId, isAsc);
        case 'Applicant':
          return this.commonService.compare(
            a.applicantName,
            b.applicantName,
            isAsc,
          );
        case 'ProgrammeType':
          return this.commonService.compare(
            a.programmeType,
            b.programmeType,
            isAsc,
          );
        case 'Country':
          return this.commonService.compare(a.country, b.country, isAsc);
        case 'City':
          return this.commonService.compare(a.hometown, b.hometown, isAsc);
        case 'Sex':
          return this.commonService.compare(a.gender, b.gender, isAsc);
        case 'Status':
          return this.commonService.compare(a.status, b.status, isAsc);
        case 'applicantType':
          return this.commonService.compare(a.status, b.status, isAsc);
        default:
          return 0;
      }
    });

    this.dataSource = new MatTableDataSource(this.sortedApplicants);
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  get filterCount(): number {
    return this.dataSource ? this.dataSource.filteredData.length : 0;
  }




}
